import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProcessModule, provideDefaultConfigFactory, StateConfig, StateTransferType } from '@spartacus/core';
import { ARTICLE_FEATURE } from './article-state';
import { reducerProvider, reducerToken } from './reducers';

function articleStoreConfigFactory(): StateConfig {
  return {
    state: {
      ssrTransfer: {
        keys: { [ARTICLE_FEATURE]: StateTransferType.TRANSFER_STATE },
      },
      // TODO CHECK! articleSearch?
      // storageSync: {
      //   keys: {
      //     articleSearch: StorageSyncType.SESSION_STORAGE,
      //   },
      // },
    },
  };
}

@NgModule({
  imports: [ProcessModule.forRoot(), StoreModule.forFeature(ARTICLE_FEATURE, reducerToken)],
  providers: [provideDefaultConfigFactory(articleStoreConfigFactory), reducerProvider],
})
export class ArticleStoreModule {}
